// extracted by mini-css-extract-plugin
module.exports = {"name":"ListItems_name__136mm","id":"ListItems_id__39kVs"};